import { Drawer, DrawerHeader, DrawerBody } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import styles from './product-core-desposit.module.scss';
import cx from 'classnames';

const ProductCoreDepositDrawer = ({ drawerProps }) => {
  const t = useTranslations();

  return (
    <Drawer
      {...drawerProps}
      orientation="bottom"
      verticalMaxHeight="default"
      className={styles['product-core-deposit__drawer']}
    >
      <DrawerHeader>
        <h4
          className={cx('cat-u-theme-typography-title-sm m-0 u-color--Black ')}
        >
          {t('CAT_CORE_DEPOSIT_TITLE')}
        </h4>
      </DrawerHeader>
      <DrawerBody>
        <p
          className={cx(
            styles['product-core-deposit__drawer-body-content'],
            'cat-u-theme-typography-body-sm m-0'
          )}
        >
          {t('CAT_CORE_UNIT_SELL')}
        </p>
      </DrawerBody>
    </Drawer>
  );
};

export default ProductCoreDepositDrawer;
